import { useId } from 'react';

// In React 19.0 and older the useId hook returns a string with trailing and leading colons. This is not valid
// CSS syntax and document.querySelector will throw on selectors with colons.
// From 19.1.0 the useId hook returns a valid CSS selector string using « and ». This however does not work for
// Swedbank Pay which throws an error.
// TLDR: get rid of those characters and return something simpler
export const useDomSafeId = () => useId().replaceAll(/[:«»]/g, '__');
